<ng-container *ngIf="showAllFields">
    <div class="row">
        <div class="col-9">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Address</mat-label>
                <input id="autocompletePlaces" ngx-google-places-autocomplete [options]='options' [(ngModel)]="addressFieldModel" (ngModelChange)="onModelChange($event)" #placesRef="ngx-places" [required]="addressIsRequired"
                       placeholder="Enter Address" type="text" matInput (onAddressChange)="handleAddressChange($event)" />
            </mat-form-field>
        </div>
        <div class="col-3">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Unit Number</mat-label>
                <input placeholder="Unit #" type="text" matInput [formControl]="unitNumberControl" (ngModelChange)="onModelChange($event)">
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>City</mat-label>
                <input placeholder="Enter City" type="text" matInput [formControl]="cityControl" [required]="addressIsRequired" (ngModelChange)="onModelChange($event)">
            </mat-form-field>
        </div>
        <div class="col-3">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>State</mat-label>
                <input placeholder="State" type="text" matInput [formControl]="stateControl" (ngModelChange)="onModelChange($event)" [required]="addressIsRequired">
            </mat-form-field>
        </div>
        <div class="col-3">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Zip Code</mat-label>
                <input placeholder="Zip Code" type="number" matInput [formControl]="zipControl" [required]="addressIsRequired" (ngModelChange)="onModelChange($event)">
            </mat-form-field>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!showAllFields">
    <div class="row">
        <div class="col-12">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Address</mat-label>
                <!-- <input placeholder="Enter Address" type="text" matInput [formControl]="addressControl" [matAutocomplete]="auto"> -->
                <input id="autocompletePlaces" ngx-google-places-autocomplete [(ngModel)]="addressFieldModel" (ngModelChange)="onModelChange($event)"
                 [options]='options' #placesRef="ngx-places" placeholder="Enter Address" type="text" matInput 
                 (onAddressChange)="handleAddressChange($event)" />
                <!-- <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngIf="(isAddressLoading$ | async)">
                        <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
                    </mat-option>
                    <mat-option *ngFor="let address of addressList | async" [value]="address">
                        {{address.name}}
                    </mat-option>
                </mat-autocomplete> -->
            </mat-form-field>
        </div>
    </div>

    <div class="row" *ngIf="!streetOnly">
        <div class="col-6">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Unit Number</mat-label>
                <input placeholder="Enter Unit Number" type="text" matInput [formControl]="unitNumberControl">
            </mat-form-field>
        </div>
        
        <div class="col-6">
            <mat-form-field appearance="outline" floatLabel="always" class="col-6">
                <mat-label>Zip Code</mat-label>
                <input placeholder="Enter Zip Code" type="number" matInput [formControl]="zipControl">
            </mat-form-field>
        </div>
    </div>
        
</ng-container>
